import React from 'react';
import { FileText, CheckSquare, Globe, File } from 'lucide-react';
import type { SharedItem } from '../../types/inner-circle';

interface SharedItemsProps {
  items: SharedItem[];
  onViewItem: (item: SharedItem) => void;
}

export function SharedItems({ items, onViewItem }: SharedItemsProps) {
  const getItemIcon = (type: SharedItem['type']) => {
    switch (type) {
      case 'task':
        return <CheckSquare className="w-5 h-5" />;
      case 'note':
        return <FileText className="w-5 h-5" />;
      case 'challenge':
        return <Globe className="w-5 h-5" />;
      default:
        return <File className="w-5 h-5" />;
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Shared Items</h3>
      <div className="space-y-2">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => onViewItem(item)}
            className="w-full flex items-center gap-3 p-3 bg-black/20 rounded-xl hover:bg-black/30 transition-colors text-left"
          >
            <div className="w-10 h-10 rounded-xl bg-[var(--accent-color)]/20 flex items-center justify-center text-[var(--accent-color)]">
              {getItemIcon(item.type)}
            </div>
            <div>
              <div className="text-sm text-gray-400 capitalize">{item.type}</div>
              <div className="text-sm">
                Shared on {item.created_at.toLocaleDateString()}
              </div>
            </div>
          </button>
        ))}
        {items.length === 0 && (
          <div className="text-center py-8 text-gray-400">
            No items shared yet
          </div>
        )}
      </div>
    </div>
  );
}